<template>
    <section class="content">
      <!-- <keep-alive> -->
      <div id="overlay" v-if="loading">
        <div class="spinner"></div>
        <br />
        <h4>Loading...</h4>
      </div>
      <div>
        <div class="box box-info">
          <!-- <Toast style="margin-top: 35px" /> -->
          <form>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-2">
                <label for="fromDate">From Date</label>
                <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
              </div>
  
              <div class="p-field p-col-12 p-md-2">
                <label for="toDate">To Date</label>
                <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate" />
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button @click.prevent="searchProfitLossAnalysis" class="p-button-raised" label="Search"
                  icon="pi pi-search" />
                <!-- <button type="submit" style="margin-left:10px;margin-top: 24px;"  @click.prevent="reset"
               class="btn btn-info pull-left">Reset</button> -->
              </div>
            </div>
          </form>
          <!-- <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-col-12">
              <a href="#" @click.prevent="exportCSV()">
                <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;" />
              </a> -->
              <DataTable :value="profitAnalysisList" ref="po" :paginator="true" :rowsPerPageOptions="[100, 500, 1000]" :rows="100"
                :filters="filters" class="p-datatable-responsive p-datatable-gridlines" data-key="id">
                <template #header>
            <div style="text-align: left">
              <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
            </div>
          </template>
                <Column header="S.N">
                  <template #body="sl">
                    {{ sl.index + 1 }}
                  </template>
                </Column>
                <Column header="Date" headerStyle="width:8em;" :sortable="true" field="salesDateEnglish"
                   filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['salesDateEnglish']" />
                  </template>
                </Column>
                <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="salesDate"
                   filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['salesDate']" />
                  </template>
                </Column>
                <Column header="Bill No" :sortable="true" field="billNo"  filterMatchMode="contains">
  
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['billNo']" />
                  </template>
                 
                </Column>
                <Column header="Customer" :sortable="true" field="accountName" filterField="accountName"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
                  </template>
                </Column>

                <Column header="Item" :sortable="true" field="itemName" filterField="itemName"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['itemName']" />
                  </template>
                  <template #footer>
                    Total:
                  </template>
                </Column>

                <Column header="Code" :sortable="true" field="itemCode" filterField="itemCode"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['itemCode']" />
                  </template>
                  
  
                </Column>
                <Column header="Sales" :sortable="true" field="salesAmount" filterField="salesAmount" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['salesAmount']" />
                  </template>
                  <template #footer>
                    {{ totalSales.toFixed(2) }}
                  </template>
                </Column>

                <Column header="Purchase" bodyStyle="text-align: right" field="purchaseAmount"
                  filterField="purchaseAmount" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['purchaseAmount']" />
                  </template>
                  <template #footer>
                    {{ totalPurchase.toFixed(2) }}
                  </template>
                </Column>

                <Column header="Profit" bodyStyle="text-align: right" field="profit" filterField="profit"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['profit']" />
                  </template>
                  <template #footer>
                    {{ totalProfit.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Sales Vat" bodyStyle="text-align: right" field="salesVat" filterField="salesVat"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['salesVat']" />
                  </template>
                  <template #footer>
                    {{ totalSalesVat.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Purchase Vat" bodyStyle="text-align: right" field="purchaseVat" filterField="purchaseVat"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['purchaseVat']" />
                  </template>
                  <template #footer>
                    {{ totalPurchaseVat.toFixed(2) }}
                  </template>
                </Column>
                <Column header="Vat Difference" bodyStyle="text-align: right" field="vatDifference" filterField="vatDifference"
                  filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['vatDifference']" />
                  </template>
                  <template #footer>
                    {{ totalVatDifference.toFixed(2) }}
                  </template>
                </Column>
                <template #empty>No record found</template>
              </DataTable>
            <!-- </div>
          </div> -->
        </div>
      </div>
    </section>
  </template>
  <script>
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import Dialog from '../../layout/dialog'
  import $ from 'jquery'
  import Button from 'primevue/button'
  import InputMask from 'primevue/inputmask'
  import InputText from 'primevue/inputtext'
  
  export default {
    name: 'purchaseSummaryReport',
    data() {
      return {
        fromDate: null,
        toDate: null,
        profitAnalysisList: [],
        loading: false,
        dialogShow: false,
        englishDateEnabled: true,
        filters: {},
        totalSales: 0,
        totalPurchase: 0,
        totalProfit: 0,
        totalSalesVat: 0,
        totalPurchaseVat: 0,
        totalVatDifference: 0
      }
    },
    mounted() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    methods: {
      async searchProfitLossAnalysis() {
        let dat = {
          fromDate: this.fromDate,
          toDate: this.toDate
        }
        this.loading = !this.loading
        let resp = await this.$store.dispatch('loadProfitLossAnalysisAccountItemWiseReport', dat)
        this.loading = false
        if (resp.length <= 0) {
          this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 10000 })
        } else {
          this.profitAnalysisList = resp
          this.totalBalance()
        }
      },
      exportCSV() {
        this.$refs.po.exportCSV()
      },
      totalBalance() {
        this.totalSales = 0.0
        this.totalPurchase = 0.0
        this.totalProfit = 0.0
        this.totalSalesVat = 0.0
        this.totalPurchaseVat = 0.0
        this.totalVatDifference = 0.0
        for (let sale of this.profitAnalysisList) {
          this.totalSales += sale.salesAmount
          this.totalPurchase += sale.purchaseAmount
          this.totalProfit += sale.profit
          this.totalSalesVat += sale.salesVat
          this.totalPurchaseVat += sale.purchaseVat
          this.totalVatDifference += sale.vatDifference
        }
      },
      reset() {
        if (!this.$store.getters.englishDate) {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        } else {
          this.fromDate = new Date().toISOString().slice(0, 10)
          this.toDate = new Date().toISOString().slice(0, 10)
        }
      },
      cancel(data) {
        this.dialogShow = false
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      },
      setNepaliDate() {
        if (this.$store.getters.nepaliNewDate !== '') {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        }
      },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
          return
        } else {
          this.englishDateEnabled = false
          return
        }
      },
      nepaliDate() {
        $('#fromDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.fromDate = $('#fromDate').val()
          }
        })
        $('#toDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.toDate = $('#toDate').val()
          }
        })
      }
    },
    components: {
      DatePicker,
      DataTable,
      Column,
      Dialog,
      Button,
      InputMask,
      InputText
    }
  }
  </script>
  <style scoped src="@../../../static/css/purchase.css"></style>



// WEBPACK FOOTER //
// profitAndLossAnalysisAccountAndProduct.vue?2320c444